import InfoDocEN from '@intelligence/_locales/en-US';
import InfoDocCN from '@intelligence/_locales/zh-CN';

// export const METRICS_INFOS: {
//   [key: string]: {
//     name: string;
//     nameTips: string | React.ReactElement;
//     nameTipsCN: string | React.ReactElement;
//     dataSource: 'appnnie' | 'mscience' | 'npd' | (string & {});
//     entityType: 'mobile' | 'pc' | 'console';
//     segment: string;
//     subSegment: string;
//   };
// } = {
//   downloads: {
//     name: 'Downloads',
//     nameTips: InfoDocEN.dbi_info_sum_selected,
//     nameTipsCN: InfoDocCN.dbi_info_sum_selected,
//     dataSource: 'appnnie',
//     entityType: 'mobile',
//     segment: 'mobile',
//     subSegment: 'downloads',
//   },
//   revenue: {
//     name: 'Mobile Revenue',
//     nameTips: InfoDocEN.dbi_info_sum_selected,
//     nameTipsCN: InfoDocCN.dbi_info_sum_selected,
//     dataSource: 'appnnie',
//     entityType: 'mobile',
//     segment: 'mobile',
//     subSegment: 'revenue',
//   },
//   pc_company_mscience: {
//     name: 'PC Digital Revenue',
//     nameTips: InfoDocEN.dbi_info_revenue_from_mscience_datasource_tips,
//     nameTipsCN: InfoDocCN.dbi_info_revenue_from_mscience_datasource_tips,
//     dataSource: 'mscience',
//     entityType: 'pc',
//     segment: 'pc',
//     subSegment: 'digitalRevenue',
//   },
//   pc_company_npd: {
//     name: 'PC Physical Revenue',
//     nameTips: InfoDocEN.dbi_info_revenue_from_npd_datasource_tips,
//     nameTipsCN: InfoDocCN.dbi_info_revenue_from_npd_datasource_tips,
//     dataSource: 'npd',
//     entityType: 'pc',
//     segment: 'pc',
//     subSegment: 'physicalRevenue',
//   },
//   console_company_mscience: {
//     name: 'Console Digital Revenue',
//     nameTips: InfoDocEN.dbi_info_revenue_from_mscience_datasource_tips,
//     nameTipsCN: InfoDocCN.dbi_info_revenue_from_mscience_datasource_tips,
//     dataSource: 'mscience',
//     entityType: 'console',
//     segment: 'console',
//     subSegment: 'digitalRevenue',
//   },
//   console_company_npd: {
//     name: 'Console Physical Revenue',
//     nameTips: InfoDocEN.dbi_info_revenue_from_npd_datasource_tips,
//     nameTipsCN: InfoDocCN.dbi_info_revenue_from_npd_datasource_tips,
//     dataSource: 'npd',
//     entityType: 'console',
//     segment: 'console',
//     subSegment: 'physicalRevenue',
//   },
// };
export const METRICS_INFOS: {
  [key: string]: {
    name: string;
    nameTips: string | React.ReactElement;
    nameTipsCN: string | React.ReactElement;
    dataSource: 'appnnie' | 'mscience' | 'npd' | (string & {});
    entityType: 'mobile' | 'pc' | 'console';
    segment: string;
    subSegment: string;
  };
} = {
  
  company_appannie_downloads: {
    name: 'Downloads',
    nameTips: InfoDocEN.dbi_info_sum_selected,
    nameTipsCN: InfoDocCN.dbi_info_sum_selected,
    dataSource: 'appnnie',
    entityType: 'mobile',
    segment: 'mobile',
    subSegment: 'downloads',
  },
  company_appannie_revenue: {
    name: 'Mobile Revenue',
    nameTips: InfoDocEN.dbi_info_sum_selected,
    nameTipsCN: InfoDocCN.dbi_info_sum_selected,
    dataSource: 'appnnie',
    entityType: 'mobile',
    segment: 'mobile',
    subSegment: 'revenue',
  },
  company_mscience_pc_revenue: {
    name: 'PC Digital Revenue',
    nameTips: InfoDocEN.dbi_info_revenue_from_mscience_datasource_tips,
    nameTipsCN: InfoDocCN.dbi_info_revenue_from_mscience_datasource_tips,
    dataSource: 'mscience',
    entityType: 'pc',
    segment: 'pc',
    subSegment: 'digitalRevenue',
  },
  company_npd_pc_revenue: {
    name: 'PC Physical Revenue',
    nameTips: InfoDocEN.dbi_info_revenue_from_npd_datasource_tips,
    nameTipsCN: InfoDocCN.dbi_info_revenue_from_npd_datasource_tips,
    dataSource: 'npd',
    entityType: 'pc',
    segment: 'pc',
    subSegment: 'physicalRevenue',
  },
  company_mscience_console_revenue: {
    name: 'Console Digital Revenue',
    nameTips: InfoDocEN.dbi_info_revenue_from_mscience_datasource_tips,
    nameTipsCN: InfoDocCN.dbi_info_revenue_from_mscience_datasource_tips,
    dataSource: 'mscience',
    entityType: 'console',
    segment: 'console',
    subSegment: 'digitalRevenue',
  },
  company_npd_console_revenue: {
    name: 'Console Physical Revenue',
    nameTips: InfoDocEN.dbi_info_revenue_from_npd_datasource_tips,
    nameTipsCN: InfoDocCN.dbi_info_revenue_from_npd_datasource_tips,
    dataSource: 'npd',
    entityType: 'console',
    segment: 'console',
    subSegment: 'physicalRevenue',
  },
};
